import {
  AbsoluteCenter,
  Box,
  Button,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import Lottie from "lottie-react";
import InventoryPerson from "../animations/inventory.json";
import { API_URL, PRIMARY_COLOR, SSO_URL } from "helpers/constants";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

export default function Signin() {
  const [params] = useSearchParams();
  const completeAuth = params.get("complete_auth");

  useEffect(() => {
    if (completeAuth === "true") {
      fetch(`${API_URL}/auth/refresh`, {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mode: "session" }),
      }).catch((error) => {
        console.error("@@@ Error:", error);
      });
    }
  }, [completeAuth]);

  return (
    <Box zIndex={99} height="100vh" w="100%" bg={PRIMARY_COLOR}>
      <AbsoluteCenter>
        <Stack
          direction={["column-reverse", "row"]}
          alignItems={"center"}
          spacing={8}
        >
          <Box>
            <Lottie animationData={InventoryPerson} loop />
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            bg="whiteAlpha.200"
            padding={16}
          >
            <Text
              fontSize="4xl"
              color="white"
              textAlign="center"
              mb={8}
              whiteSpace="nowrap"
            >
              {process.env.REACT_APP_NAME ?? "Inventory"}
            </Text>
            <Link colorScheme="blue" href={SSO_URL}>
              <Button colorScheme="blue">Sign in with Office 365</Button>
            </Link>
          </Box>
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}
